/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4dea4448&lang=css"

const __exports__ = script;

export default __exports__